var _style, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 283.5 54.1",
    style: {
      enableBackground: "new 0 0 283.5 54.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#154D82;}\n\t.st1{fill:#2A78BD;}\n\t.st2{fill:#4AABE1;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "30.9,32.6 18.8,32.6 24.8,43 30.9,43 39.9,37.8   "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "48.7,21.2 40.3,16.3 9.4,16.3 15.1,26.1 40.3,26.1   "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "49.8,9.8 58.2,4.9 49.8,0 49.8,0 49.7,0 49.7,0 49.7,0 49.7,0 49.7,0 49.7,0 0,0 5.7,9.8 49.7,9.8     49.7,9.8 49.7,9.8 49.8,9.8   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.1,5.8c0-2.8,2.4-5.2,5.2-5.2c2.8,0,5.2,2.4,5.2,5.2S73.1,11,70.3,11C67.4,11,65.1,8.7,65.1,5.8z    M65.9,13.6h8.7v28.9h-8.7V13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107.9,24.7v17.7h-8.7V26c0-3.6-2.3-5.3-5-5.3c-3.2,0-5.4,1.9-5.4,6v15.8h-8.7V13.6h8.7v2.7   c1.6-2.1,4.5-3.5,8.3-3.5C102.9,12.8,107.9,16.9,107.9,24.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M124.9,21.9v10.2c0,2.5,2.1,2.7,6,2.5v7.9c-11.3,1.2-14.6-2.3-14.6-10.3V21.9h-4.6v-8.3h4.6V8.1l8.7-2.6v8.1h6   v8.3H124.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M149.8,35.6c2.4,0,4.4-0.9,5.5-2.2l6.9,4c-2.8,3.9-7.1,6-12.6,6c-9.9,0-16-6.6-16-15.3s6.2-15.3,15.4-15.3   c8.4,0,14.7,6.5,14.7,15.3c0,1.2-0.1,2.4-0.3,3.5h-20.5C144,34.5,146.6,35.6,149.8,35.6z M155.1,25c-0.9-3.4-3.5-4.6-6.1-4.6   c-3.3,0-5.5,1.6-6.3,4.6H155.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M195.6,24.7v17.7H187V26c0-3.6-2.3-5.3-5-5.3c-3.2,0-5.4,1.9-5.4,6v15.8h-8.7V13.6h8.7v2.7   c1.6-2.1,4.5-3.5,8.3-3.5C190.7,12.8,195.6,16.9,195.6,24.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M212.6,21.9v10.2c0,2.5,2.1,2.7,6,2.5v7.9c-11.3,1.2-14.6-2.3-14.6-10.3V21.9h-4.6v-8.3h4.6V8.1l8.7-2.6v8.1h6   v8.3H212.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M223.4,37.8c0-3,2.5-5.5,5.5-5.5s5.5,2.5,5.5,5.5s-2.5,5.5-5.5,5.5S223.4,40.8,223.4,37.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M240.2,0.3h8.7v42.2h-8.7V0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M283.5,13.6l-9.9,28c-3.2,9.2-8.4,12.8-16.5,12.4V46c4,0,6-1.3,7.2-4.8l-11.5-27.6h9.5l6.4,17.7l5.4-17.7   H283.5z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.87a67e2305c994bfaf36853887f73462.svg";
export { ForwardRef as ReactComponent };